import * as React from 'react';
import {View} from 'react-native';
import {Field} from 'redux-form';
import {CheckboxField} from '../../../../profile/desktop/components/applicationsFilterVisuallyImpaired/components/checkboxField';
import {useStyles} from '../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../shared/theme/helpers';
import {getProductsFilterName} from '../../pipes';
import {BaseFieldWrapper} from '../../../../../shared/components/baseField';
import {PropsProductAcceptorList} from '../../model';

interface ViewProps extends PropsProductAcceptorList {}

export default ({productAcceptors, style, visuallyImpaired}: ViewProps) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    item: {
      ...mediaOnly(DeviceSize.mobile, {marginBottom: 12}, {marginBottom: 15}),
    },
    label: {
      ...mediaOnly(
        DeviceSize.mobile,
        {
          ...theme.fonts.body,
        },
        {
          ...theme.fonts.caption,
          fontSize: 20,
          lineHeight: 26,
        },
      ),
      color: theme.color.textColor,
    },
    fieldStyle: visuallyImpaired
      ? {
          justifyContent: 'flex-start',
          paddingHorizontal: 10,
        }
      : {},
  }));

  return (
    <View style={style}>
      <View key={0} style={styles.item}>
        <Field
          component={visuallyImpaired ? CheckboxField : BaseFieldWrapper}
          type='checkbox'
          name={getProductsFilterName(String(0), 'productAcceptor')}
          label={'Все'}
          labelStyle={styles.label}
          style={styles.fieldStyle}
        />
      </View>
      {productAcceptors
        ? productAcceptors.map(({id, label}) => (
            <View key={id} style={styles.item}>
              <Field
                component={visuallyImpaired ? CheckboxField : BaseFieldWrapper}
                type='checkbox'
                name={getProductsFilterName(String(id), 'productAcceptor')}
                label={label}
                labelStyle={styles.label}
                style={styles.fieldStyle}
              />
            </View>
          ))
        : null}
    </View>
  );
};
